// initialRecommendedPrice is in cents, and 0 when the order came without one (the detail then shows no crossed price either)
export function getReferencePrice(lineItems) {
    return lineItems.reduce((acc, item) => acc + (item.initialRecommendedPrice ? item.initialRecommendedPrice / 100 : item.retailerOriginalPrice), 0);
}
